import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { ExerciceService } from '../Services/ExerciceService';

const { Option } = Select;

const Exercice = ({ onExerciceChange, source }) => {
  const [exercices, setExercices] = useState([]);
  const [selectedExercice, setSelectedExercice] = useState('');
  const exerciceService = new ExerciceService();

  useEffect(() => {
    const fetchExercices = async (source) => {
      try {
        const data = source === 'compta' ? await exerciceService.getAllExercices() : await exerciceService.getAllExercicesDoc();
        const sorted = [...data].sort((a, b) => b - a);
        setExercices(sorted);

        // Sélectionner la dernière année disponible
        const lastYear = Math.max(...data); // Prendre la plus grande année de la liste
        setSelectedExercice(lastYear.toString());
        onExerciceChange(lastYear.toString()); // Communiquer le changement
      } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
      }
    };

    fetchExercices(source);
  }, []);

  const handleExerciceChange = (value) => {
    setSelectedExercice(value);
    onExerciceChange(value); // Appeler le callback à chaque changement d'exercice
  };

  return (
    <div>
      <Select
        value={selectedExercice}
        bordered={false}
        onChange={handleExerciceChange}
        style={{ borderBottom: '2px solid #030303' }}
      >
        {exercices.map((exercice) => (
          <Option key={exercice} value={exercice.toString()}>
            {exercice}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default Exercice;
